var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgServersideIconExportDiagram = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "12.15 12 26.25 26.25",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HILFSLINIEN"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ICONS_UMGEWANDELT"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#818994",
    d: "M30.557,25.849c-0.345,0-0.625,0.28-0.625,0.625v3.275c0,0.139-0.112,0.251-0.251,0.251h-8.826 c-0.138,0-0.25-0.112-0.25-0.251v-3.275c0-0.345-0.28-0.625-0.625-0.625s-0.625,0.28-0.625,0.625v3.275 c0,0.828,0.673,1.501,1.5,1.501h8.826c0.828,0,1.501-0.673,1.501-1.501v-3.275C31.182,26.129,30.901,25.849,30.557,25.849z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#818994",
    d: "M24.465,27.26c0.19,0.257,0.483,0.404,0.803,0.404c0.001,0,0.001,0,0.002,0 c0.319,0,0.611-0.148,0.802-0.405l1.281-1.726c0.227-0.305,0.262-0.705,0.091-1.045s-0.514-0.551-0.894-0.551h-0.657v-4.312 c0-0.345-0.28-0.625-0.625-0.625s-0.625,0.28-0.625,0.625v4.312h-0.656c-0.38,0-0.723,0.211-0.894,0.551 c-0.171,0.339-0.136,0.74,0.091,1.045L24.465,27.26z M26.55,24.938l-1.282,1.727l-1.281-1.727H26.55z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DADFE6",
    d: "M25.268,12c-7.237,0-13.125,5.888-13.125,13.125S18.03,38.25,25.268,38.25s13.125-5.888,13.125-13.125 S32.505,12,25.268,12z M25.268,37c-6.548,0-11.875-5.327-11.875-11.875S18.72,13.25,25.268,13.25s11.875,5.327,11.875,11.875 S31.815,37,25.268,37z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ICONS_PFADE",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#DADFE6",
    strokeWidth: 1.25,
    cx: 25.268,
    cy: 25.125,
    r: 12.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#818994",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M19.979,26.473v3.276c0,0.484,0.392,0.876,0.876,0.876h8.826c0.484,0,0.876-0.392,0.876-0.876v-3.276"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#818994",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 25.268,
    y1: 19.625,
    x2: 25.268,
    y2: 24.096
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#818994",
    strokeMiterlimit: 10,
    d: "M25.669,26.962l1.282-1.727c0.245-0.33,0.009-0.798-0.401-0.798 h-2.563c-0.411,0-0.646,0.468-0.401,0.798l1.282,1.727C25.066,27.231,25.469,27.231,25.669,26.962z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "BESCHRIFTUNG"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgServersideIconExportDiagram, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/serverside-icon-export-diagram.4fefb4d8.svg";
export { ForwardRef as ReactComponent };